import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { useAdminCostsApi } from "../../http/costs/api";
import { formatCurrency, formatDate } from "../../types/utils";
import HistoryDialog from "../ui/HistoryDialog";
import VersionDialog from "../ui/VersionDialog";

type CostHistoryDialogProps = {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
};

const CostHistoryDialog: FC<CostHistoryDialogProps> = ({
  itemToShowVersionsId,
  itemVersionToShowVersions,
  onClose,
}) => {
  const i18n = useI18n();
  const costsApi = useAdminCostsApi();

  return (
    <HistoryDialog
      title={i18n.t.costs.versions}
      entityId={itemToShowVersionsId}
      lastVersion={itemVersionToShowVersions}
      getHistory={costsApi.getAdminCostHistory}
      getEntityVersionHook={costsApi.getAdminCostVersion}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <>
          <VersionDialog.Table headers={headers}>
            {(dataVersion.current?.car?.id ?? null) !== (dataVersion.next.car?.id ?? null) && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.cars.singular}
                  value={
                    dataVersion.current?.car?.currentPlateNumber ||
                    dataVersion.current?.car?.vehicleIdentificationNumber
                  }
                  edited={dataVersion.next.car?.currentPlateNumber || dataVersion.next.car?.vehicleIdentificationNumber}
                />
              </tr>
            )}
            {(dataVersion.current?.type?.id ?? null) !== (dataVersion.next.type?.id ?? null) && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.type}
                  value={dataVersion.current?.type?.name}
                  edited={dataVersion.next.type?.name}
                />
              </tr>
            )}
            {dataVersion.current?.date != dataVersion.next.date && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.date}
                  value={dataVersion.current && formatDate(dataVersion.current?.date, i18n.language)}
                  edited={formatDate(dataVersion.next.date, i18n.language)}
                />
              </tr>
            )}
            {dataVersion.current?.costNet != dataVersion.next.costNet && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.costNet}
                  value={dataVersion.current && `${formatCurrency(dataVersion.current?.costNet, i18n.language)}`}
                  edited={`${formatCurrency(dataVersion.next.costNet, i18n.language)}`}
                />
              </tr>
            )}
            {dataVersion.current?.costGross != dataVersion.next.costGross && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.costGross}
                  value={dataVersion.current && `${formatCurrency(dataVersion.current?.costGross, i18n.language)}`}
                  edited={`${formatCurrency(dataVersion.next.costGross, i18n.language)}`}
                />
              </tr>
            )}
          </VersionDialog.Table>
        </>
      )}
    />
  );
};

export default CostHistoryDialog;
